<template>
  <el-checkbox-group
      v-model="innerVM"
      value=""
      v-bind="$attrs"
  >
    <slot />
  </el-checkbox-group>
</template>

<script setup>
/**
 * 能够把复选框el-checkbox-group  自动由数组 --> 指定分隔符的字符串
 * 注意此组件绑定的 <el-checkbox label="第三个月" :value="3"/> value只能为字符串，3不能为number。暂无需优化处理，因组件最终为字符串。
 */
const props = defineProps({
  modelValue: { // 默认选中的多选
    type: [String, Array],
    default: undefined
  },
  sepChar: { // 分隔符
    type: String,
    default: ','
  },
})

const emit = defineEmits(['update:modelValue'])

const innerVM = computed({
  get:() => {
    return props.modelValue && typeof props.modelValue.split == 'function' &&
        props.modelValue.split(props.sepChar) || []
  },
  set: val => {
    emit('update:modelValue', val.join(props.sepChar))
  }
})
</script>

<style scoped>

</style>
